import React from 'react';

import * as S from './styles';

const Slide3: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Jardineira, B.Luxo, R$ 580. Regata,
          <br /> Intimissimi, R$ 199. Macacão branco,
          <br /> Macacão, Isabel Marant (usado como capa), R$ 8.090.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide3 };
